<!--<ngx-spinner [fullScreen]="false" type="ball-spin-fade-rotating" size="medium">-->
<ngx-spinner [fullScreen]="false" type="ball-clip-rotate-pulse" size="medium">
  <p class="loading">Loading ...</p>
</ngx-spinner>
